"use client";

import * as React from "react";
import { CreditCard, LayoutDashboard, FileText, HelpCircle, Settings, LucideIcon, FileEdit, ListTodo } from "lucide-react";
import { DiscordLogoIcon } from "@radix-ui/react-icons";
import { NavMain } from "@/components/dashboard/nav-main";
import { NavUser } from "@/components/dashboard/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  useSidebar,
} from "@/components/ui/sidebar";
import Logo from "@/components/shared/Logo";
import { cn } from "@/lib/utils";

// Navigation items
const navMain = [
  {
    title: "Dashboard",
    url: "/dashboard",
    icon: LayoutDashboard,
  },
  {
    title: "Cloud tasks",
    url: "/dashboard/tasks",
    icon: ListTodo,
  },
  {
    title: "PDF Editor",
    url: "/edit-pdf-with-ai",
    icon: FileEdit,
  },
  {
    title: "Snippets",
    url: "/dashboard/snippets",
    icon: FileText,
  },
  {
    title: "Billing",
    url: "/dashboard/billing",
    icon: CreditCard,
  },
  
];

export function DashboardSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <div className={cn("flex items-center gap-2 py-1 transition-all duration-300 ease-in-out", isCollapsed ? "pl-1" : "px-1")}>
          <div
            className={`overflow-hidden transition-all duration-300 ease-in-out ${
              isCollapsed ? "w-[28px]" : "w-full"
            }`}
          >
            <Logo
              className={cn(
                "block w-auto transition-all duration-300 ease-in-out h6"
              )}
              variant="light"
            />
          </div>
        </div>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navMain} />
      </SidebarContent>
      <SidebarFooter>
        <NavMain items={[
          {
            title: "Settings",
            url: "/dashboard/settings",
            icon: Settings,
          },
          {
            title: "Help & Support",
            url: "/dashboard/help",
            icon: HelpCircle,
          },
          {
            title: "Discord Community",
            url: "https://discord.gg/68UEdfHtFT",
            icon: DiscordLogoIcon as LucideIcon,
          },
        ]} />
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  );
}
